const initialState = {
  pendingSettlements: [],
  settledSettlements: [],
  currentDueVehicles: [],
  previousSettlements: [],
  settlementSummary: {},
  settlementUploadSheet: {},
  settlementUploadSheetError: "",
};
export default initialState;
